<template>
  <div>
    <!--面包屑-->
    <breadcrumb-link :title="getTitle"></breadcrumb-link>
    <!--内容区域-->
    <div>
      <el-form
        class="box-detail"
        label-width="130px"
        ref="detail"
        :inline="true"
        :model="detail"
        :disabled="getDisabled"
      >
        <div class="edit-title">基础信息</div>
        <el-form-item
          label="Source名称"
          label-width="220px"
          prop="name"
          :rules="[{required: true, message: '必填'}]"
        >
          <el-col :span="24">
            <el-input
              class="main-input"
              placeholder="必填，不超过50个字符"
              maxlength="50"
              show-word-limit
              v-model="detail.name"
            ></el-input>
          </el-col>
        </el-form-item>

        <div class="edit-title">字段信息</div>
        <el-form-item
          label="Source类型:"
          label-width="220px"
          prop="sourceType"
          :rules="[{required: true, message: '必填'}]"
        >
          <el-select v-model="detail.sourceType" :disabled="getSelectDisabled" placeholder="请选择" @change="selectChange()" >
            <el-option label="Kafka" value="Kafka"></el-option>
            <el-option label="Canal" value="Canal"></el-option>
            <el-option label="Mongo" value="Mongo"></el-option>
          </el-select>
        </el-form-item>
        <div v-if="detail.sourceType == 'Kafka'&& detail.pipelineKafkaSourceVO">
          <el-form-item label="Partition选择:" label-width="220px" prop="pipelineKafkaSourceVO.partitionId" :rules="[{required: true, message: '必填'}]">
            <el-select
              filterable
              v-model="detail.pipelineKafkaSourceVO.kafkaId"
              placeholder="Kafka集群选择"
              style="margin-right:19px"
              value-key="id"
              @change="getTopicList(detail.pipelineKafkaSourceVO.kafkaId, true)"
              :disabled="getSelectDisabled"
            >
              <el-option
                  v-for="(itm, idx) in kafkaList"
                  :key="idx"
                  :label="itm.name"
                  :value="itm.id"></el-option>
            </el-select>
            <el-select
              filterable
              v-model="detail.pipelineKafkaSourceVO.topicId"
              placeholder="Topic选择"
              style="margin-right:18px"
              value-key="id"
              @change="getPartitionList(detail.pipelineKafkaSourceVO.topicId, true)"
              :disabled="getSelectDisabled"
            >
              <el-option
                  v-for="(itm, idx) in topicList"
                  :key="idx"
                  :label="itm.name"
                  :value="itm.id"></el-option>
            </el-select>
            <el-select filterable v-model="detail.pipelineKafkaSourceVO.partitionId" placeholder="Partition选择" value-key="id" :disabled="getSelectDisabled">
              <el-option
                  v-for="(itm, idx) in partitionList"
                  :key="idx"
                  :label="itm.num + ''"
                  :value="itm.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="group_id:" label-width="220px" prop="pipelineKafkaSourceVO.groupId" :rules="[{required: true, message: '必填'}]">
            <el-input placeholder="请输入group_id" style="width:193px" v-model="detail.pipelineKafkaSourceVO.groupId" :disabled="getSelectDisabled"></el-input>
          </el-form-item>
          <el-form-item label="单次拉取最长时间:" label-width="220px" prop="pipelineKafkaSourceVO.pollDuration" :rules="[{required: true, message: '必填'}]">
            <el-input placeholder="请输入单次拉取最长时间" style="width:193px" v-model="detail.pipelineKafkaSourceVO.pollDuration"><i slot="suffix">MS</i></el-input>
          </el-form-item>
          <el-form-item label="连接空闲的最大时间:" label-width="220px" prop="pipelineKafkaSourceVO.connectionMaxIdle" :rules="[{required: true, message: '必填'}]">
            <el-input placeholder="请输入连接空闲的最大时间" style="width:193px" v-model="detail.pipelineKafkaSourceVO.connectionMaxIdle"></el-input>
          </el-form-item>
          <el-form-item label="kafka首次启动消费位置:" label-width="220px" prop="pipelineKafkaSourceVO.offsetReset" :rules="[{required: true, message: '必填'}]">
            <el-input placeholder="请输入kafka首次启动消费位置" style="width:193px" v-model="detail.pipelineKafkaSourceVO.offsetReset" :disabled="getSelectDisabled"></el-input>
          </el-form-item>
          <el-form-item label="单次拉取最大条数:" label-width="220px" prop="pipelineKafkaSourceVO.maxPollRecords" :rules="[{required: true, message: '必填'}]">
            <el-input placeholder="请输入单次拉取最大条数" style="width:193px" v-model="detail.pipelineKafkaSourceVO.maxPollRecords"></el-input>
          </el-form-item>
          <el-form-item label="单次拉取最大字节数:" label-width="220px" prop="pipelineKafkaSourceVO.fetchMaxBytes" :rules="[{required: true, message: '必填'}]">
            <el-input placeholder="请输入单次拉取最大字节数" style="width:193px" v-model="detail.pipelineKafkaSourceVO.fetchMaxBytes"></el-input>
          </el-form-item>
          <el-form-item label="用于数据转换的类的全名:" label-width="220px" prop="pipelineKafkaSourceVO.convertClassName" :rules="[{required: true, message: '必填'}]">
            <el-input placeholder="用于数据转换的类的全名" style="width:617px" v-model="detail.pipelineKafkaSourceVO.convertClassName" :disabled="getSelectDisabled"></el-input>
          </el-form-item>
        </div>
        <div v-else-if="detail.sourceType == 'Canal' &&detail.pipelineCanalSourceVO">
          <el-form-item label="物理库db:" label-width="220px" prop="pipelineCanalSourceVO.physicalDbId" :rules="[{required: true, message: '必填'}]">
            <el-select filterable v-model="detail.pipelineCanalSourceVO.physicalDbId" placeholder="物理库db" style="margin-right:19px" value-key="id">
              <el-option
                  v-for="(itm, idx) in dbList"
                  :key="idx"
                  :label="itm.name"
                  :value="itm.id"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="单次拉取最大条数:" label-width="220px" prop="pipelineCanalSourceVO.batchSize" :rules="[{required: true, message: '必填'}]">
            <el-input placeholder="请输入单次拉取最大条数"  v-model="detail.pipelineCanalSourceVO.batchSize"></el-input>
          </el-form-item>

          <el-form-item label="timeout_mills:" label-width="220px" prop="pipelineCanalSourceVO.timeoutMills" :rules="[{required: true, message: '必填'}]">
            <el-input placeholder="请输入timeout_mills" v-model="detail.pipelineCanalSourceVO.timeoutMills"><i slot="suffix">MS</i></el-input>
          </el-form-item>
        </div>

        <div v-else-if="detail.sourceType == 'Mongo' && detail.pipelineMongoSourceVO">
          <el-form-item label="物理库db:" label-width="220px" prop="pipelineMongoSourceVO.physicalDbId" :rules="[{required: true, message: '必填'}]">
            <el-select filterable v-model="detail.pipelineMongoSourceVO.physicalDbId" placeholder="物理库db" style="margin-right:19px" value-key="id">
              <el-option
                  v-for="(itm, idx) in dbList"
                  :key="idx"
                  :label="itm.name"
                  :value="itm.id"
                  ></el-option>
            </el-select>
          </el-form-item>
            </el-select>
          <el-form-item label="单次拉取最大条数:" label-width="220px" prop="pipelineMongoSourceVO.batchSize" :rules="[{required: true, message: '必填'}]">
            <el-input placeholder="请输入单次拉取最大条数" v-model="detail.pipelineMongoSourceVO.batchSize"></el-input>
          </el-form-item>

          <el-form-item label="timeout_mills:" label-width="220px" prop="pipelineMongoSourceVO.timeoutMills" :rules="[{required: true, message: '必填'}]">
            <el-input placeholder="请输入timeout_mills" v-model="detail.pipelineMongoSourceVO.timeoutMills"><i slot="suffix">MS</i></el-input>
          </el-form-item>
        </div>
        <div v-if=" type == 'details' ">
          <history-record
            :historyTitle="historyTitle"
            :historyList="historyList"/>
        </div>
      </el-form>
      <div style="padding-left: 130px">
        <el-button
          type="primary"
          @click="submitForm('detail')" v-if="type!='details'">保存
        </el-button>
        <el-button type="info" plain @click="goBack">返回</el-button>
      </div>
    </div>
  </div>
</template>
<script>
  import BreadcrumbLink from '../../../components/breadcrumbLink';
  import util from '@/utils/util';
  import HistoryRecord from '../../../components/common/historyRecord';
  import {
    getSourceInfo,
    addSource,
    editSource,
    getKafkaList,
    getTopicList,
    getPartitionList,
    getDbList
  } from '@/apis/pipelineService/pipelineConfig';

  export default {
    components: {
      HistoryRecord,
      BreadcrumbLink,
    },
    data() {
      return {
        type: '', // 跳转页面获取标题
        detail: {
          name: '',  // pipeline名称
          sourceType: null,
          pipelineCanalSourceVO: {
            physicalDbId: null,
            batchSize: 2000,
            timeoutMills: 1000
          },
          pipelineKafkaSourceVO: {
            partitionId: null,
            groupId: null,
            pollDuration: 200,
            connectionMaxIdle: 54000,
            offsetReset: "latest",
            maxPollRecords: 2000,
            fetchMaxBytes: 52428800,
            convertClassName: "com.wanshun.bigdata.pipeline.common.converter.LogConverter",
            kafkaId:null
          },
          pipelineMongoSourceVO: {
            physicalDbId: null,
            batchSize: 2000,
            timeoutMills: 1000
          },
        },
        kafkaList: null,
        topicList: null,
        partitionList: null,
        dbList: null,
        historyTitle: '记录信息', // 记录信息标题
        historyList: [], // 记录信息信息内容
        id: this.$route.query.id,
        sourceType: this.$route.query.sourceType,
      };
    },
    computed: {
      getDisabled() {
        return {
          'add': false,
          'edit': false,
          'details': true
        }[this.type];
      },
      getSelectDisabled() {
        return {
          'add': false,
          'edit': true,
          'details': true
        }[this.type];
      },
      getTitle() {
        return {
          'add': '新增Source配置',
          'edit': '修改Source配置',
          'details': 'Source配置详情'
        }[this.type];
      },
    },
    mounted() {
      this.type = this.$route.query.type;
      if (this.type != 'add') {
        this.getDetails()
        this.getKafkaList()
      }

    },
    methods: {
      selectChange(value) {
        if(this.detail.sourceType == 'Kafka') {
          this.getKafkaList()
        }else {
          this.getDbList()
        }
      },
      // 返回上一层
      goBack() {
        this.$router.go(-1);
      },
      async getTopicList(id, clear) {
        if(clear) {
          this.detail.pipelineKafkaSourceVO.topicId = null
          this.detail.pipelineKafkaSourceVO.partitionId = null
        }
        let params = {
          kafkaClusterID: id
        }
        try {
          const data = await getTopicList(params)
          if(data.code == 0 && data.data) {
            this.topicList = data.data
          }else {
            this.$message.error(data.message);
          }
        }catch(error) {
          console.log(error)
        }
      },
      async getPartitionList(id, clear) {
        if(clear) this.detail.pipelineKafkaSourceVO.partitionId = null
        let params = {
          topicID: id
        }
        try {
          const data = await getPartitionList(params)
          console.log(data.data)
          if(data.code == 0 && data.data) {
            this.partitionList = data.data
          }else {
            this.$message.error(data.message);
          }
        }catch(error) {
          console.log(error)
        }
      },
      async getKafkaList() {
        let params = {
          current:1,
          size:100
        }
        try {
          const data = await getKafkaList(params);
          if(data.code == 0 && data.data) {
            this.kafkaList = data.data.records
          }else {
            this.$message.error(data.message);
          }
        }catch(error) {
          console.log(error)
        }
      },
      async getDbList(physicalId) {
        let params = {
          sourceType: this.detail.sourceType || this.sourceType,
          physicalId,
        }
        try {
          const data = await getDbList(params);
          if(data.code == 0 && data.data) {
            this.dbList = data.data
          }else {
            this.$message.error(data.message);
          }
        }catch(error) {
          console.log(error)
        }
      },
      // 详情
      async getDetails() {
        let params = {
          id: this.id,
          sourceType: this.sourceType
        };
        try {
          const data = await getSourceInfo(params);
          if (data.code == 0 && data.data) {
            this.detail = data.data;
            if(this.type != 'add') {
              if(data.data.sourceType == 'Kafka') {
                this.getTopicList(data.data.pipelineKafkaSourceVO.kafkaId)
                this.getPartitionList(data.data.pipelineKafkaSourceVO.topicId)
              }else if(data.data.sourceType == 'Canal'){
                this.getDbList(data.data.pipelineCanalSourceVO.physicalDbId)
              }else {
                this.getDbList(data.data.pipelineMongoSourceVO.physicalDbId)
              }
            }
            this.historyList = [
            {
              label: '创建人：',
              value: data.data.creatorName,
            }, {
              label: '创建时间：',
              value: data.data.createTime.replace(/T/g,' '),
            },
            {
              label: '最后修改人：',
              value: data.data.updatorName,
            }, {
              label: '修改时间：',
              value: data.data.updateTime.replace(/T/g,' '),
            }];

          }else {
            this.$message.error(data.message);
          }
        } catch (error) {
        }
      },
      // 提交表单
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.pushForm();
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      // 提交
      async pushForm() {
        let params = {
          ...this.detail
        }
        if (this.type == 'add') { delete params.id }
        try {
          const data = this.type == 'add' ? await addSource(params) : await editSource(params);
          if (data.code == 0) {
            this.$router.go(-1);
            this.$message.success(data.message);
          } else {
            this.$message.error(data.message);
          }
        } catch (error) {
        }
      },
    }
  };
</script>

<style lang="scss">
  .box-detail {
    width: 850px;
    .main-input {
      width: 400px;
    }
  }
</style>
